import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  isRefundReturnFromModel,
  validateIsRefundReturnCondition,
  type IsRefundReturnState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_REFUND_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsRefundReturnState>>,
): ConditionType<IsRefundReturnState, ModelCondition.IsRefundReturn> => ({
  name: CONDITION_NAMES[ModelCondition.IS_REFUND_RETURN],
  description() {
    return t("Requested refund on return.");
  },
  Details(props: ConditionTypeDetailsProps<IsRefundReturnState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return isRefundReturnFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.IS_REFUND_RETURN, orderCount: state };
  },
  valid(state) {
    return validateIsRefundReturnCondition(state).valid;
  },
});
